var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from "@tanstack/vue-query";
import { computed, toValue } from "vue";
import CampaignSummaryEndpoints from "src/shared/api/campaign/CampaignSummaryEndpoints";
import { transforms } from "src/resources/programs/transforms";
import { queryKeys } from "src/resources/queryKeys";
import CampaignSummary from "src/shared/store/campaign-summary/model/CampaignSummary";
import { createDurationMeasurement } from "src/shared/measurement";
import Session from "Session";
const STATE_ORDER = {
    NOT_LAUNCHED: 0,
    LIVE: 1,
    PAUSED: 2,
    ENDED: 3,
    STOPPED: 4,
    ARCHIVED: 5,
};
const getLastPublishedTime = (campaign) => {
    return campaign.last_published_date
        ? new Date(campaign.last_published_date).getTime()
        : 0;
};
const sortCampaigns = (campaigns) => {
    return campaigns.slice().sort((campaign1, campaign2) => {
        var _a, _b;
        const stateOrder1 = (_a = STATE_ORDER[campaign1.state]) !== null && _a !== void 0 ? _a : Number.POSITIVE_INFINITY;
        const stateOrder2 = (_b = STATE_ORDER[campaign2.state]) !== null && _b !== void 0 ? _b : Number.POSITIVE_INFINITY;
        const difference = stateOrder1 - stateOrder2;
        if (difference === 0) {
            return (getLastPublishedTime(campaign1) -
                getLastPublishedTime(campaign2));
        }
        return difference;
    });
};
export const usePrograms = (parameters = {
    include_archived: true,
}) => {
    return useQuery({
        queryKey: computed(() => queryKeys.programs(toValue(parameters))),
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const clientId = Session.getInstance().getClientId();
            const measurement = createDurationMeasurement("load_all_programs").withData({
                clientId: clientId,
            });
            try {
                const parametersValue = toValue(parameters);
                const responses = yield CampaignSummaryEndpoints.getCampaignSummaries({
                    include_archived: parametersValue.include_archived,
                });
                const campaignSummaries = responses.map((response) => new CampaignSummary(response));
                const marketingCampaigns = campaignSummaries.filter((campaign) => campaign.isMarketingCampaign());
                const sortedCampaigns = sortCampaigns(marketingCampaigns);
                return transforms.toPrograms(sortedCampaigns);
            }
            finally {
                measurement.send();
            }
        }),
    });
};
